var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaskCross = function SvgMaskCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.281 5.719a.94.94 0 0 1 0 1.406L13.406 12l4.875 4.875c.422.422.422 1.031 0 1.406-.375.422-.984.422-1.406 0L12 13.406l-4.875 4.875c-.422.422-1.031.422-1.406 0-.422-.375-.422-.984 0-1.406L10.594 12 5.719 7.125c-.422-.422-.422-1.031 0-1.406.375-.422.984-.422 1.406 0L12 10.594l4.875-4.875c.422-.422 1.031-.422 1.406 0"
  })));
};
export default SvgMaskCross;